export const TOGGLE_THEME = "TOGGLE_THEME";
export const TOGGLE_THEME_DEFAULT = "TOGGLE_THEME_DEFAULT";
export const DISPLAY_SNACKBAR = "DISPLAY_SNACKBAR";
export const CLOSE_SNACKBAR = "CLOSE_SNACKBAR";

export const SET_USER_ACCESS = "SET_USER_ACCESS";
export const CLEAR_USER_ACCESS = "CLEAR_USER_ACCESS";

export const ADD_TASK_TO_TASKLIST = "ADD_TASK_TO_TASKLIST";
export const REMOVE_TASK_FROM_TASKLIST = "REMOVE_TASK_FROM_TASKLIST";
export const UPDATE_TASK_IN_TASKLIST = "UPDATE_TASK_IN_TASKLIST";
export const SET_TASK_LIST = "SET_TASK_LIST";

export const POLL_TASKS = "POLL_TASKS";
export const ROOT_CHANGE = "ROOT_CHANGE";

export const SWITCH_LANGUAGE = "SWITCH_LANGUAGE";
